<template>
  <div class="inventory-container">
    <div class="inventory-header">
      <h2>Detail PC Inventory</h2>
    </div>

    <div class="inventory-detail-account">
      <div class="account-info">
        <p class="label">Name</p>
        <p class="val">{{ dataUser.fullname }}</p>
      </div>
      <div class="account-info">
        <p class="label">HIN</p>
        <p class="val">{{ dataUser.hin }}</p>
      </div>
      <div class="account-info">
        <p class="label">Total Gram</p>
        <p class="val">{{ dataUser.gram }} <small>gr</small></p>
      </div>
    </div>

    <div class="inventory-stack">
      <div
        v-for="(item, index) in detailData"
        :key="index"
      >
      <template v-if="item.contract_id !== 10 && item.contract_id !== 6">
        <div class="inventory-wide-card">

          <div class="info-block main-identity">
            <span class="gold-badge">Gold Contract</span>
            <h3>{{ item.contract_name }}</h3>
          </div>
  
          <div class="info-block metrics-grid">
            <div class="weight-summary">
              <span class="lbl">Gold Gram</span>
              <span class="val-gold"
                >{{ formatPrice(Math.abs(item.gram_buy - item.gram_sell)) }} <small>gr</small></span
              >
            </div>
          </div>
  
          <div class="info-block highlight-action">
            <router-link :to="`/user-participant/${paramId}/${item.contract_id}_${Math.abs(item.gram_buy - item.gram_sell)}`">
              <button class="action-view-btn" :disabled="Math.abs(item.gram_buy - item.gram_sell) === 0">
                List Block <b-icon icon="eye"></b-icon>
              </button>
            </router-link>
          </div>
        </div>
      </template>
      </div>
    </div>
  </div>
</template>

<script>
import { contract } from '../../utils/contract';

export default {
  name: "ParticipantPageKMIDetail",
  data() {
    return {
      detailData: null,
      accountId: null,
      hin: null,
      dataUser: null,
      displayContract : contract
    };
  },
  mounted() {
    const id = this.$route.params.id;
    const splitId = id.split("_");
    this.dataUser = {
      account_id: splitId[0],
      hin: splitId[1],
      fullname: splitId[2],
      gram: splitId[3]
    }
    this.$store.dispatch("getDetailTradeAccount", this.dataUser.account_id).then((response) => {
      this.detailData = response.body.body;
    });
  },
  methods: {
    formatPrice(value) {
      let val = Math.round((value + Number.EPSILON) * 100) / 100;
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    fixNetting(value, contractId){
      return this.formatPrice(this.displayContract[contractId] === 'DG001' ? value * 0.01 : value)
    }
  },
  computed: {
    paramId(){
      return `${this.dataUser.account_id}_${this.dataUser.hin}_${this.dataUser.fullname}`;
    }
  }
};
</script>
<style scoped>
.inventory-header h2 {
  font-size: 24px;
  color: #1e293b;
  margin: 0 0 2rem 0;
  font-weight: 700;
}
.inventory-stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.inventory-detail-account {
  margin-bottom: 24px;
}

.account-info {
  display: flex;
  gap: 8px;
  align-items: center;
}

.account-info .label {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 600;
  letter-spacing: 0.5px;
  width: 100px;
}
/* Card Utama Full Width */
.inventory-wide-card {
  width: 100%;
  background: white;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
  padding: 2rem 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  transition: all 0.2s ease;
}
.inventory-wide-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
}
.gold-badge {
  background-color: #f3e5ab;
  color: #aa7c11;
  font-size: 11px;
  font-weight: 700;
  padding: 4px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-block;
  margin-bottom: 8px;
}
.main-identity h3 {
  font-size: 18px;
  color: #0f172a;
  margin: 0 0 4px 0;
}
.sub-id {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}
.info-block {
  min-width: 150px;
}
.border-divider-left {
  border-left: 1px solid #f1f5f9;
  padding-left: 20px;
}
.metrics-grid {
  display: flex;
  gap: 32px;
  border-left: 1px solid #e2e8f0;
  border-right: 1px solid #e2e8f0;
  padding: 0 4rem;
}
.metric-item {
  display: flex;
  flex-direction: column;
}
.lbl {
  font-size: 11px;
  text-transform: uppercase;
  color: #94a3b8;
  font-weight: 600;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  margin-right: 8px;
}
.val {
  font-size: 15px;
  font-weight: 700;
  color: #334155;
}
.val small {
  font-weight: 400;
  color: #64748b;
}
.physical-stock {
  border-right: 1px solid #e2e8f0;
  padding-right: 32px;
}
.highlight-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
}
.weight-summary {
  text-align: right;
}
.val-gold {
  font-size: 2rem;
  font-weight: 800;
  color: #d4af37;
}
.val-gold small {
  font-size: 14px;
  color: #64748b;
  font-weight: 500;
}
.action-view-btn {
  background-color: #1e293b;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s;
}
.action-view-btn:hover {
  background-color: #0f172a;
}

.action-view-btn:disabled {
  background-color: #cbd5e1;
  cursor: not-allowed;
}

/* Responsif Layar Kecil / Tablet */
@media (max-width: 992px) {
  .inventory-wide-card {
    flex-direction: column;
    align-items: flex-start;
  }
  .metrics-grid,
  .physical-stock {
    border: none;
    padding: 0;
    width: 100%;
    justify-content: space-between;
  }
  .highlight-action {
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #e2e8f0;
    padding-top: 16px;
  }
}
</style>
